import React from "react";

const ProductDetailsTable = ({ productDetails }) => {
    return (
        <div className="overflow-x-auto mt-6">
            <h3 className="text-lg font-semibold mb-4">Product Details</h3>

            <table className="min-w-full table-fixed border-collapse border border-gray-400 rounded-2xl">
                <thead className="bg-gray-100 text-xs text-gray-600 uppercase tracking-wider">
                    <tr>
                        <th className="p-4 border border-gray-400">Image</th>
                        <th className="p-4 border border-gray-400">Name</th>
                        <th className="p-4 border border-gray-400">Brand</th>
                        <th className="p-4 border border-gray-400">Color</th>
                        <th className="p-4 border border-gray-400">Size</th>
                        <th className="p-4 border border-gray-400">Pack</th>
                        <th className="p-4 border border-gray-400">Weight</th>
                        <th className="p-4 border border-gray-400">Quantity</th>
                        <th className="p-4 border border-gray-400">Price</th>
                        <th className="p-4 border border-gray-400">Total</th>
                    </tr>
                </thead>
                <tbody>
                    {(productDetails || []).map((product) => (
                        <tr key={product._id} className="hover:bg-gray-50 rounded-xl">
                            <td className="p-4 border border-gray-400">
                                <img
                                    src={product?.images?.[0]}
                                    alt="product"
                                    className="w-16 h-16 object-cover rounded"
                                />
                            </td>
                            <td className="p-4 border border-gray-400">{product?.name}</td>
                            <td className="p-4 border border-gray-400">{product?.brand}</td>
                            <td className="p-4 border border-gray-400">{product?.color}</td>
                            <td className="p-4 border border-gray-400">{product?.selectedSize}</td>
                            <td className="p-4 border border-gray-400">{product?.selectedPack}</td>
                            <td className="p-4 border border-gray-400">{product?.weight}</td>
                            <td className="p-4 border border-gray-400">{product?.quantity}</td>
                            <td className="p-4 border border-gray-400">${product?.price}</td>
                            <td className="p-4 border border-gray-400 font-semibold">${product?.total}</td>
                        </tr>
                    ))}
                </tbody>
            </table>
        </div>
    );
};

export default ProductDetailsTable;
